import { Link } from 'react-router-dom';

export const NotFoundPage = () => (
  <div className="error">
    <h2>Page not found</h2>
    <p>The page you are looking for does not exist.</p>
    <Link to="/" className="load-more-button">
      Back to Home
    </Link>
  </div>
);

